import React, { useContext, useState } from "react";
import LoadingAction from "../../../themes/LoadingAction/LoadingAction";
import "./EditPagamento.css";
import { Button, Input } from "antd";
import { AuthContext } from "../../../contexts/AuthContext";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import * as links from "../../../utils/links";
import axios from "axios";
import question_icon from "../../../assets/images/question.png";

const EditPagamento = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const maquinaInfos = location.state || {};
  const { authInfo, setNotiMessage, setDataUser } = useContext(AuthContext);
  const { dataUser } = authInfo;
  const token = dataUser?.token;
  const { id } = useParams();

  const [data, setData] = useState({
    nome: maquinaInfos?.nome ?? "",
    descricao: maquinaInfos?.descricao ?? "",
    store_id: maquinaInfos?.store_id ?? "",
    maquininha_serial: String(maquinaInfos?.maquininha_serial ?? ""),
    valorDoPulso: maquinaInfos?.pulso ?? 0,
  });
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (name, value) => {
    setData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => {
      const next = { ...prev };
      delete next[name];
      return next;
    });
  };

  const onSave = async () => {
    const errorsTemp = {};
    if (String(data.nome).trim() === "") errorsTemp.nome = "Este campo é obrigatório";
    if (Object.keys(errorsTemp).length) {
      setErrors(errorsTemp);
      return;
    }

    setIsLoading(true);
    try {
      await axios.put(
        `${process.env.REACT_APP_SERVIDOR}/maquina-cliente`,
        {
          id,
          nome: data.nome,
          store_id: String(data.store_id),
          maquininha_serial: String(data.maquininha_serial),
        },
        { headers: { "x-access-token": token, "content-type": "application/json" } }
      );
      navigate(links.DASHBOARD_FORNECEDOR);
    } catch (err) {
      if ([401, 403].includes(err?.response?.status)) {
        setNotiMessage({ type: "error", message: "A sua sessão expirou, para continuar faça login novamente." });
        navigate(dataUser?.key === "ADMIN" ? links.ADMIN_SIGNIN : links.SIGNIN);
        setDataUser(null);
      } else if (err?.response?.status === 400) {
        setNotiMessage({ type: "error", message: err.response?.data?.error || "Não foi possível salvar." });
        setErrors((prev) => ({ ...prev, nome: "Já existe uma máquina com esse nome" }));
      } else {
        setNotiMessage({ type: "error", message: "Não foi possível salvar as alterações." });
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="PagamentosSearch_container">
      {isLoading && <LoadingAction />}
      <div className="PagamentosSearch_header">
        <div className="PagamentosSearch_header_left">
          <div className="Dashboard_staBlockTitle">Editar Máquina</div>
        </div>
        <Button
          className="EditPagamentos_header_back"
          onClick={() => navigate(`${links.FORNECEDOR_SEARCH_CANAIS}/${id}`, { state: location.state })}
        >
          <span>VOLTAR</span>
        </Button>
      </div>

      <div className="Update_Pagamento_content">
        <div className="Update_Pagamento_itemField">
          <label className="Update_Pagamento_itemFieldLabel" htmlFor="nome">Nome:</label>
          <Input
            value={data.nome}
            id="nome"
            onChange={(event) => handleChange("nome", event.target.value)}
            className={errors.nome ? "Update_Pagamento_inputError" : ""}
          />
          {errors.nome && <div className="Update_Pagamento_itemFieldError">{errors.nome}</div>}
        </div>

        <div className="Update_Pagamento_itemField">
          <label className="Update_Pagamento_itemFieldLabel" htmlFor="descricao">Descrição:</label>
          <Input
            value={data.descricao}
            id="descricao"
            readOnly
            className="client-protected-field"
            title="Somente o administrador pode alterar a descrição."
          />
          <small className="client-protected-note">Somente o administrador pode alterar este campo.</small>
        </div>

        <div className="Update_Pagamento_itemField">
          <label className="Update_Pagamento_itemFieldLabel" htmlFor="store_id" style={{ display: "flex", alignItems: "center" }}>
            <span>Store_id:</span>
            <Button
              className="EditPagamentos_header_HelpPage"
              onClick={() => navigate(links.HELP_PAGE, { state: { ...location.state, redirect_url: `${links.EDIT_FORNECEDOR_CANAIS}/${id}` } })}
              disabled={isLoading}
            >
              <img className="Edit_Pagamento_Icon" src={question_icon} alt="ajuda" />
            </Button>
          </label>
          <Input value={data.store_id} id="store_id" onChange={(event) => handleChange("store_id", event.target.value)} />
        </div>

        <div className="AddMachine_itemField">
          <label className="AddMachine_itemFieldLabel" htmlFor="maquininha_serial">Maquininha_serial:</label>
          <Input value={data.maquininha_serial} id="maquininha_serial" onChange={(event) => handleChange("maquininha_serial", event.target.value)} />
        </div>

        <div className="Update_Pagamento_itemField">
          <label className="Update_Pagamento_itemFieldLabel" htmlFor="valorDoPulso">Valor do Pulso R$:</label>
          <Input
            value={data.valorDoPulso}
            id="valorDoPulso"
            type="number"
            readOnly
            className="client-protected-field"
            title="Somente o administrador pode alterar o valor do pulso."
          />
          <small className="client-protected-note">Somente o administrador pode alterar este campo.</small>
        </div>

        <Button className="Update_Pagamento_saveBtn" onClick={onSave} disabled={isLoading}>
          SALVAR ALTERAÇÕES
        </Button>

        <Button
          className="Update_Pagamento_deleteBtn client-delete-locked action-delete"
          disabled
          title="Somente o administrador pode excluir máquinas."
        >
          EXCLUIR MÁQUINA
        </Button>
        <small className="client-protected-note">Exclusão de máquina disponível somente para o administrador.</small>
      </div>
    </div>
  );
};

export default EditPagamento;
